import "./App.scss";
import { WebRoutes } from "./Routes";

function App() {
  return <WebRoutes />;
}

export default App;
